// extracted by mini-css-extract-plugin
export default {"root":"clash-module___root___dff42311"};